function setRemUnit() {
  const designWidth = 750; // 与 postcss-pxtorem 的 rootValue 对应（750px 设计稿）
  const screenWidth = document.documentElement.clientWidth || document.body.clientWidth;

  let fontSize;
  if (screenWidth > 1024) {
    // PC 端（>1024px）：固定根字体 16px，不影响单独拆分的 PC 样式
    fontSize = 16;
  } else if (screenWidth <= 768) {
    // 1. 移动端（≤768px）：放大系数设为 1.8~2（确保文字清晰）
    const minScreenWidth = 320; // 最小支持屏幕宽度（避免超小屏变形）
    const actualWidth = Math.max(screenWidth, minScreenWidth);
    const baseFontSize = (actualWidth / designWidth) * 75; // 基础计算值

    const mobileScale = 1.8; // 移动端放大系数（可根据视觉微调，如 1.9/2）
    const scaledFontSize = baseFontSize * mobileScale;

    // 移动端最小根字体（确保超小屏文字不小于 30px）
    const mobileMinFont = 30;
    fontSize = Math.max(scaledFontSize, mobileMinFont);
  } else {
    // 2. 平板端（769px~1024px）：放大系数设为 1.2~1.5（避免文字过大）
    const actualWidth = Math.min(screenWidth, 1024); // 最大按 1024px 计算
    const baseFontSize = (actualWidth / designWidth) * 75; // 基础计算值

    const tabletScale = 0.8; // 平板端放大系数（可微调，如 1.3/1.4）
    const scaledFontSize = baseFontSize * tabletScale;

    // 平板端最小根字体（确保文字不小于 24px）
    const tabletMinFont = 24;
    fontSize = Math.max(scaledFontSize, tabletMinFont);
  }

  // 应用最终根字体大小
  document.documentElement.style.fontSize = `${fontSize}px`;
}

// 初始化 + 监听窗口变化（屏幕跨断点时自动切换系数）
setRemUnit();
window.addEventListener("resize", setRemUnit);
window.addEventListener("load", setRemUnit);
